import { render, staticRenderFns } from "./serveDes.vue?vue&type=template&id=b89a3318&scoped=true&"
import script from "./serveDes.vue?vue&type=script&lang=js&"
export * from "./serveDes.vue?vue&type=script&lang=js&"
import style0 from "./serveDes.vue?vue&type=style&index=0&id=b89a3318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89a3318",
  null
  
)

export default component.exports